import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule }  from '@angular/http';
import { LoaderComponent } from './loader.component';
import { SharedModule } from '../../shared/shared.module';
import { LoaderService } from '../../shared/_services/loader.service';

@NgModule({
  imports: [
  CommonModule,
  SharedModule
  ],
  declarations: [LoaderComponent],
  exports: [LoaderComponent],
  providers: [LoaderService]
})
export class LoaderModule { }


// WEBPACK FOOTER //
// ./src/app/components/loader/loader.module.ts